import React from 'react';
import { Box, Container, CssBaseline } from '@mui/material';
import Header from './Header';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <CssBaseline />
      <Header />
      <Box component="main" sx={{ flexGrow: 1, py: 3, width: '100%', minWidth: 0, overflow: 'auto', px: { xs: 1, sm: 2 } }}>
        {children}
      </Box>
    </Box>
  );
};

export default Layout; 